import {BasicScenario} from '../../../allkey/framework/parameters/BasicScenario';

export class ChronoCodeScenario extends BasicScenario {
manageChronoCodeLevels: boolean | null;
manageFreedatas: boolean | null;
manageHierarchy: boolean | null;
}

